module.exports = __webpack_public_path__ + "static/media/OrdenForLightBg.2d48f166.png";